import React, {useState,useRef,useEffect} from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import _ from "../../i18n";
import { useQuery } from "react-query";
import { TiArrowSortedDown } from "react-icons/ti";
import TTPFilterHorizontalBar from "../common/Filter/TTPFilterHorizontalBar";
import { useOnClickOutside, renderTeamYears} from "../../utils";
import { getCollaboratorsSuggestions,getCategoriesSuggestions ,getClientsSuggestions} from "../../api";
import { getPartners } from "../../api/partners";
import { DateRangePicker } from "react-dates";
import {
  CLIENT_GROUP_CRM_FILTER,
  CLIENT_CRM_TYPE_FILTER,
  TYPE_PERIODE_FILTER,
  NOT_CLIENT_FILTER,
} from "../../config";
const TimeSheetFilter = ({
  selectedYear,
  filters,
  setFilters,
  filterVisible,
  nbResult,
  resetFilter,
  customAddOn,
  selectedClients,
  collaborator,
  preferences
}) => {
  const yearsWrapperRef = useRef(null);
  const [clientOptions, setClientOptions] = useState([]);
  const [collaboratorOptions, setCollaboratorOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [partnersOptions, setPartnersOptions] = useState([]);
  const [startDate, setStartDate] = useState(moment("2025-01-01", "YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment(`2025-${moment().format("MM-DD")}`, "YYYY-MM-DD"));
  const [selectYear, setSelectYear] = useState("2025");


  
  const handleCollaboratorsChange = (items) => {
    setFilters({ ...filters, collaborators: items });
  };
  const handleTypeCRMClientChange = (items) => {
   
    setFilters({ ...filters, clientCRMTypes: items });
  };
  const handleClientsChange = (items) => {
   
    setFilters({ ...filters, clients: items });
  };
  const handletaskcategoryChange = (items) => {
   
      setFilters({ ...filters, Types: items });
  };
  const handleYearsChange = (selectedYear) => {
    setSelectYear(selectedYear);
    setYearDivIsVisible(false);
  
    const currentYear = new Date().getFullYear();
    const isCurrentYear = parseInt(selectedYear) === currentYear;
    if (isCurrentYear) {
      const currentMonthDay = moment().format("MM-DD");
      setStartDate(moment(`${selectedYear}-01-01`, "YYYY-MM-DD"));
      setEndDate(moment(`${selectedYear}-${currentMonthDay}`, "YYYY-MM-DD"));
    } else {
      setStartDate(moment(`${selectedYear}-01-01`, "YYYY-MM-DD"));
      setEndDate(moment(`${selectedYear}-12-31`, "YYYY-MM-DD"));
    }
    
    let updatedPeriods = [];
  
    if (filters.periodUnit === 'year') {
      updatedPeriods = [`${selectedYear}`];
  
    } else if (filters.periodUnit === 'semester') {
      const semesters = isCurrentYear ? [moment().month() < 6 ? 1 : 2] : [1, 2];
      updatedPeriods = semesters.map(s => `${selectedYear}/${s}`);
  
    } else if (filters.periodUnit === 'quarter') {
      const maxQuarter = isCurrentYear ? Math.ceil((new Date().getMonth() + 1) / 3) : 4;
      const quarters = Array.from({ length: maxQuarter }, (_, i) => i + 1);
      updatedPeriods = quarters.map(quarter => `${selectedYear}/${quarter}`);
  
    } else if (filters.periodUnit === 'month') {
      const maxMonth = isCurrentYear ? new Date().getMonth() + 1 : 12;
      const months = Array.from({ length: maxMonth }, (_, i) => i + 1);
      updatedPeriods = months.map(month => `${selectedYear}/${String(month).padStart(2, '0')}`);
  
    } else if (filters.periodUnit === 'date') {
      const startDate = `${selectedYear}-01-01`;
      const endDate = `${selectedYear}-12-31`;
      updatedPeriods = [`${startDate}|${endDate}`];
    }
    setFilters({ ...filters, periods: updatedPeriods });
  
  };
  
  
  useEffect(() => {
  if (selectYear && filters.periodUnit === 'date') {
    const newStart = moment(`${selectYear}-01-01`, "YYYY-MM-DD");
    const newEnd = moment(`${selectYear}-12-31`, "YYYY-MM-DD");
    setStartDate(newStart);
    setEndDate(newEnd);
    setFilters({
      ...filters,
      periods: [`${newStart.format("YYYY-MM-DD")}|${newEnd.format("YYYY-MM-DD")}`],
    });
  }
}, [selectYear, filters.periodUnit]);

const handlePeriodUnitChange = (items) => {
  const currentYear = new Date().getFullYear();
  const isCurrentYear = parseInt(selectYear) === currentYear;
  if (isCurrentYear) {
    const currentMonthDay = moment().format("MM-DD");
    setStartDate(moment(`${selectedYear}-01-01`, "YYYY-MM-DD"));
    setEndDate(moment(`${selectedYear}-${currentMonthDay}`, "YYYY-MM-DD"));
  } else {
    setStartDate(moment(`${selectedYear}-01-01`, "YYYY-MM-DD"));
    setEndDate(moment(`${selectedYear}-12-31`, "YYYY-MM-DD"));
  }
  

  let periods = [];

  if (items === 'year') {
    periods = [`${selectYear}`];

  } else if (items === 'semester') {
    const semesters = isCurrentYear ? [moment().month() < 6 ? 1 : 2] : [1, 2];
    periods = semesters.map(s => `${selectYear}/${s}`);

  } else if (items === 'quarter') {
    const maxQuarter = isCurrentYear ? Math.ceil((new Date().getMonth() + 1) / 3) : 4;
    const quarters = Array.from({ length: maxQuarter }, (_, i) => i + 1);
    periods = quarters.map(quarter => `${selectYear}/${quarter}`);

  } else if (items === 'month') {
    const maxMonth = isCurrentYear ? new Date().getMonth() + 1 : 12;
    const months = Array.from({ length: maxMonth }, (_, i) => i + 1);
    periods = months.map(month => `${selectYear}/${String(month).padStart(2, '0')}`);

  } else if (items === 'date') {
    const startDate = `${selectYear}-01-01`;
    const endDate = `${selectYear}-12-31`;
    periods = [`${startDate}|${endDate}`];

  }
 
  

  setFilters({ ...filters, periods: periods, periodUnit: items });

};

   const handleDateRangeChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  
    const formattedStart = startDate ? startDate.format("YYYY-MM-DD") : null;
    const formattedEnd = endDate ? endDate.format("YYYY-MM-DD") : null;
  
    setFilters({
      ...filters,
      periods: [`${formattedStart}|${formattedEnd}`],
    });
  };
  const handleGroupCRMClientChange = (items) => {
    setFilters({
      ...filters,
      clientCRMGroup: items,
    });
  };
  const handleGroupClientChange = (items) => {
    setFilters({
      ...filters,
      clientGroups: items,
    });
  };
  const handlePartnerChange = (partner) => {
    const zone = partnersOptions.find((p) => p.value === Number(partner))?.zone;
    setFilters({ ...filters, partner: Number(partner) });
  };

  const handleNotClient = (items) => {
    setFilters({ ...filters, deletedStatus: items });
  };

  const ref = useRef();
  useOnClickOutside(ref, () => setYearDivIsVisible(false));
  const { token, navCommunity } = useSelector((state) => state.auth);
  const [yearDivIsVisible, setYearDivIsVisible] = useState(false);
  const year = moment().year();
  const [localClients, setLocalClients] = useState([]);

  const years = [
    `${year - 1}/${year - 2}`,
    `${year - 1}/${year - 1}`,
    `${year}/${year - 1}`,
    `${year}/${year}`,
  ];
  let collaboratorsdQuery = useQuery(
    ["getCollaborators", token, navCommunity, filters.partner],
    async () => {
      if (token && navCommunity) {
        const partner = filters.partner;
  
        try {
          const response = await getCollaboratorsSuggestions(
            token,
            navCommunity.id
          );
          let data = response.data.data;
  
          if (partner && partner !== 0) {
            data = data.filter((item) => item !== null && item.partner?.value === partner);
          }
  
          data = data.map((t) => ({
            value: t.id,
            label: t.name,
            partner: t?.partner?.value,
            erpId: t?.erpId,       
            erpLabel: t?.erpLabel, 
          }));
  
          setCollaboratorOptions(data);
        } catch (e) {
          console.error("Error fetching collaborators:", e);
          return null;
        }
      }
    },
    {
    }
  );
  
  useEffect(() => {
    if (selectedClients) {
      setLocalClients(selectedClients);
    }
  }, [selectedClients]);
  


  let partnersQuery = useQuery(["partnersQuery", 4], async () => {
    if (token) {
      try {
        const response = await getPartners({
          token,
          organizationId: 4,
        });
        let data = response.data.data.map((partner) => ({
          value: partner.id,
          label: partner.name,
          zone: partner.zone,
        }));
        setPartnersOptions(data);
      } catch (e) {
        setPartnersOptions([]);
        return null;
      }
    }
  });

  let clientsdQuery = useQuery(
    ["getClients", token, navCommunity],
    async () => {
      if (token && navCommunity) {
        try {
          const response = await getClientsSuggestions(
            token,
            filters.clientCRMGroup,
            navCommunity.id,
            "isEntity",
            filters.year
          );
          let data = response.data.data
            .filter((item) => item !== null)
            .map((t) => {
              return {
                value: t.id,
                label: t.name,
              };
            });
          setClientOptions(data);
        } catch (e) {
          return null;
        }
      }
    }
  );
  let categoriesQuery = useQuery(
    ["categoriesQuery", 4],
    async () => {
      if (token) {
        try {
          const response = await getCategoriesSuggestions(4, token);
          let categoriesResponse = response.data.data.map((item) => {
            return { value: item.id, label: item.label["fr"] };
          });
          setCategoryOptions(categoriesResponse);
        } catch (e) {
          console.error("Error fetching categories:", e); 
          setCategoryOptions([]);
        }
      }
    }
  );

  
  const renderYearSelect = () => {
    return (
      <div
        ref={ref}
        className={
          "customed_select" +
          " " +
          (yearDivIsVisible ? "customed_select_opened" : "")
        }
        style={{
          background: "#6d7f92",
          color: "#ffffff",

        }}
      >
        <div
          className={"customed_select_header"}
          onClick={() => setYearDivIsVisible(!yearDivIsVisible)}
        >
        
          <span>{selectYear} </span>
          <div className={"actions"}>
            <div>
              <span className={"action"}>
                <TiArrowSortedDown />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={"customed_select_body"}>
            <div className={"customed_select_body_options"}>
              {renderTeamYears().map((item, index) => (
                <div
                  key={index}
                  className={"customed_select_body_option"}
                  onClick={() => handleYearsChange(item)}>
                
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };
  const timesheetfilters = [
    
    {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: false,
        isMulti: true,
        isClearable: true,
        placeholder: _("Partner"),
        options: partnersOptions,
        values: filters.partner,
        action: handlePartnerChange
      }
    },
    {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: false,
        isMulti: true,
        isClearable: true,
        isSearch: true,
        placeholder: _("collaborator"),
        options: collaboratorOptions,
        values: filters.collaborators,
        action: handleCollaboratorsChange
      }
    },
    {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: false,
        isMulti: true,
        isClearable: true,
        placeholder: _("Groupe client"),
        options:CLIENT_GROUP_CRM_FILTER,
        values: filters.clientGroups,
        action: handleGroupClientChange,
      }
    },
    {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: false,
        isMulti: true,
        isClearable: true,
        placeholder: _("client"),
        options:clientOptions,
        values:filters.clients,
        isSearch: true,
        action: handleClientsChange
      }
    },
    {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: false,
        isMulti: true,
        isClearable: true,
        placeholder: _("Categorie de prestation"),
        options:categoryOptions,
        values: filters.Types,
        action: handletaskcategoryChange
      }
    },
    {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: false,
        isMulti: true,
        isClearable: true,
        placeholder: _("clients CRM Group"),
        options:CLIENT_GROUP_CRM_FILTER,
        values: filters.clientCRMGroup,
        defaultValues: [
          _("AiSBL"),
          _("ASBL"),
          _("ASBL - Consultation"),
          _("ASBL - Partenaire"),
          _("ASBL petite entreprise"),
          _("Contact"),
          _("Fondation privée"),
          _("Indépendants"),
          _("Indépendants - Consultation"),
          _("Indépendants petite entreprise"),
          _("Partenaire"),
          _("Particuliers"),
          _("Particuliers - Consultation"),
          _("Sociétés"),
          _("Sociétés - Partenaire"),
          _("Sociétés petite entreprise"),
        ],
        action: handleGroupCRMClientChange,
      }
    },
    {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: false,
        isMulti: true,
        
        isClearable: true,
        placeholder: _("Type Client (CRM)"),
        options: CLIENT_CRM_TYPE_FILTER,
        values: filters.clientCRMTypes,
        action: handleTypeCRMClientChange
      }
    },
    {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: true,
        isClearable: true,
        placeholder: _("notClient"),
        options:NOT_CLIENT_FILTER,
        values: filters.deletedStatus,
        action: handleNotClient
      }
    },
    {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: true,
        placeholder: _("Type de periode"),
        options:TYPE_PERIODE_FILTER,
        values: filters.periodUnit,
        action: handlePeriodUnitChange,
        
      }
    },
    {
      grid: 3,
      type: "RANGE_DATE_PICKER",
      options: {
        placeholder: _("plage de dates"),
        dateRange: {
          startDate: startDate,
          endDate: endDate,
        },
        action: handleDateRangeChange,
      }
    }
    
  ];

  return (
    <div className="row align-center medium-12">
       
        <div className="medium-12">
        <TTPFilterHorizontalBar
          button
          filters={timesheetfilters}
          marginLeft={"2.5em"}
          filter={{keyWord: filters.searchWord, ...filters}}
          searchBox
          handleResetFilterContent={() => {}}
          updateFilter={setFilters}
          customAddOn={
            <>
              {renderYearSelect(year)}
              {customAddOn}
            </>
          }
          updateFilterContent={setFilters}
          filterFormIsVisible={filterVisible}
          resetFilterContent={resetFilter}
           cssClass="medium-12"
          nbResult={nbResult}
          label={_("nbrFolders")}
          
          language="en"
        />
      </div>
    </div>
  );
};

export default TimeSheetFilter;